import { render, staticRenderFns } from "./AssetGallery.vue?vue&type=template&id=4ab59060&"
import script from "./AssetGallery.vue?vue&type=script&lang=js&"
export * from "./AssetGallery.vue?vue&type=script&lang=js&"
import style0 from "./AssetGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports